import { Routes, Route, Navigate } from 'react-router-dom';
import { Root } from './routes/Root';
import { ProtectedRoute } from './routes/ProtectedRoute';
import { LoginPage } from './routes/LoginPage';
import { HomePage } from './routes/HomePage';
import { DashboardPage } from './routes/DashboardPage';
import { GuestInterviewPage } from './routes/GuestInterviewPage';

export function App() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/ja" replace />} />
      <Route path="/:locale" element={<Root />}>
        <Route path="login" element={<LoginPage />} />
        <Route
          index
          element={
            <ProtectedRoute>
              <HomePage />
            </ProtectedRoute>
          }
        />
        <Route
          path="dashboard"
          element={
            <ProtectedRoute>
              <DashboardPage />
            </ProtectedRoute>
          }
        />
        {/* Guest Interview Route - No Auth Required */}
        <Route path="interview" element={<GuestInterviewPage />} />
      </Route>
    </Routes>
  );
}
